import { render, staticRenderFns } from "./Exam-detail.vue?vue&type=template&id=67eaa514&scoped=true"
import script from "./Exam-detail.vue?vue&type=script&lang=js"
export * from "./Exam-detail.vue?vue&type=script&lang=js"
import style0 from "./Exam-detail.vue?vue&type=style&index=0&id=67eaa514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eaa514",
  null
  
)

export default component.exports